module.exports = __webpack_public_path__ + "img/icon_news4.89104fa8.png";